import React, { Component } from "react";
import Select from "react-select";

import { monthName } from "../../../utils/CommonFunction";

export default class FiscalYearsDropDown extends Component {
  get fiscalYearsDropDownList() {
    return this.props.fiscalYearsInfo.map(this.getFiscalYearDropDownObject);
  }

  get currentFiscalYearDropDownObject() {
    return this.getFiscalYearDropDownObject(
      this.props.getCurrentFiscalYear(this.props.fiscalYearsInfo)
    );
  }

  getFiscalYearDropDownObject = (obj) => {
    if (obj.yearStart === obj.yearEnd) {
      return {
        label: `${obj.yearStart} ${monthName(obj.monthStart)} to ${monthName(
          obj.monthEnd
        )}`,
        value: obj.yearStart, // year start is enough
      };
    }
    return {
      label: `${obj.yearStart} ${monthName(obj.monthStart)} to ${
        obj.yearEnd
      } ${monthName(obj.monthEnd)}`,
      value: obj.yearStart, // year start is enough
    };
  };

  handleViewLeaveBalanceYear = (event) => {
    this.props.onSelect("selectedFiscalYear", event.value);
  };

  render() {
    return (
      <div className="col-md-3">
        <div>
          <label className="col-sm-12">Select Fiscal Year</label>
        </div>
        <div className="col-md-12">
          <Select
            options={this.fiscalYearsDropDownList}
            onChange={this.handleViewLeaveBalanceYear}
            defaultValue={this.currentFiscalYearDropDownObject}
            className="react-select-container checkValidate"
            classNamePrefix="react-select"
          />
        </div>
      </div>
    );
  }
}
